
'use strict'
export const state = {
  messageArr: {},
  imagesListSeek:{}
}

export const getters = {
  messageArr: state => state.messageArr,
  imagesListSeek:  state => state.imagesListSeek
}


export const mutations = {
  setMessage (state, obj) {
    if(obj.init == '0'){
      state.messageArr[obj.storeKey] = []
      return false
    }
    
    if(obj.history == 0){
     state.messageArr[obj.storeKey].push(obj)
    }else{
      state.messageArr[obj.storeKey].unshift(obj)
    }
    
    console.log(state.messageArr)
  },
  setLmagesList(state, obj){
    if(!state.imagesListSeek[obj.storeKey]){
      state.imagesListSeek[obj.storeKey] = []
      return false
    }

    if(obj.history == 0){
     state.imagesListSeek[obj.storeKey].push(obj.message.content)
    }else{
      state.imagesListSeek[obj.storeKey].unshift(obj.message.content)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/im.js